var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogleStore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 337,
    height: 100,
    viewBox: "0 0 337 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_14476)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M323.632 99.7513H12.6866C5.84579 99.7513 0.248779 94.1543 0.248779 87.3135V12.6867C0.248779 5.84587 5.84579 0.248857 12.6866 0.248857H323.632C330.473 0.248857 336.07 5.84587 336.07 12.6867V87.3135C336.07 94.1543 330.473 99.7513 323.632 99.7513Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.632 0.248857H12.6866C5.84579 0.248857 0.248779 5.84587 0.248779 12.6867V87.3135C0.248779 94.1543 5.84579 99.7513 12.6866 99.7513H323.632C330.473 99.7513 336.07 94.1543 336.07 87.3135V12.6867C336.07 5.84587 330.473 0.248857 323.632 0.248857ZM323.632 2.23891C329.393 2.23891 334.08 6.92647 334.08 12.6867V87.3135C334.08 93.0747 329.393 97.7623 323.632 97.7623H12.6866C6.92639 97.7623 2.23883 93.0747 2.23883 87.3135V12.6867C2.23883 6.92647 6.92639 2.23891 12.6866 2.23891H323.632Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.205 25.7297C118.205 27.8138 117.588 29.4735 116.352 30.7116C114.948 32.1837 113.118 32.9203 110.868 32.9203C108.714 32.9203 106.883 32.174 105.376 30.6795C103.867 29.1859 103.114 27.3339 103.114 25.1242C103.114 22.9135 103.867 21.0625 105.376 19.568C106.883 18.0745 108.714 17.3272 110.868 17.3272C111.937 17.3272 112.961 17.5362 113.932 17.9531C114.904 18.371 115.683 18.9257 116.266 19.6205L114.954 20.9332C113.966 19.7526 112.606 19.1628 110.868 19.1628C109.297 19.1628 107.939 19.7148 106.792 20.8195C105.646 21.9255 105.072 23.3596 105.072 25.1242C105.072 26.8889 105.646 28.323 106.792 29.429C107.939 30.5337 109.297 31.0857 110.868 31.0857C112.535 31.0857 113.925 30.5307 115.037 29.4193C115.759 28.6951 116.177 27.6887 116.289 26.3961H110.868V24.6033H118.101C118.171 24.9931 118.205 25.3673 118.205 25.7297",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.205 25.7299H117.956C117.954 27.7665 117.36 29.3484 116.176 30.5359L116.173 30.5379L116.172 30.5399C114.813 31.9613 113.065 32.6687 110.868 32.6717C108.772 32.6687 107.017 31.9536 105.551 30.5038C104.089 29.0511 103.366 27.2777 103.363 25.1245C103.366 22.9702 104.089 21.1979 105.551 19.7461C107.017 18.2954 108.772 17.5792 110.868 17.5762C111.905 17.5762 112.893 17.7785 113.834 18.1817C114.777 18.5879 115.521 19.1202 116.076 19.7812L116.266 19.6207L116.091 19.4449L114.779 20.7586L114.955 20.9334L115.146 20.7742C114.112 19.5352 112.66 18.9105 110.868 18.9143C109.239 18.9123 107.806 19.4944 106.62 20.6411C105.423 21.7916 104.822 23.3063 104.824 25.1245C104.822 26.9426 105.423 28.4573 106.62 29.6078C107.806 30.7546 109.239 31.3367 110.868 31.3347C112.59 31.3377 114.058 30.7536 115.213 29.5954C115.985 28.8217 116.422 27.7501 116.537 26.4178L116.56 26.1476H111.117V24.8523H118.101V24.6036L117.856 24.6474C117.924 25.0245 117.956 25.3829 117.956 25.7299H118.205H118.454C118.454 25.3518 118.419 24.9633 118.346 24.559L118.309 24.3548H110.62V26.3964V26.6451H116.289V26.3964L116.041 26.375C115.931 27.6267 115.533 28.5692 114.861 29.2436C113.792 30.3085 112.481 30.8342 110.868 30.8372C109.356 30.8352 108.072 30.3143 106.965 29.2503C105.869 28.1901 105.324 26.8367 105.321 25.1245C105.324 23.4123 105.869 22.0588 106.965 20.9986C108.072 19.9347 109.356 19.4138 110.868 19.4118C112.551 19.4158 113.821 19.9715 114.764 21.0939L114.939 21.3018L116.442 19.7966L116.604 19.6354L116.457 19.4613C115.846 18.7327 115.031 18.1543 114.03 17.725C113.028 17.2944 111.969 17.0787 110.868 17.0787C108.657 17.0767 106.749 17.8541 105.201 19.3924C103.647 20.9277 102.864 22.8576 102.866 25.1245C102.864 27.3904 103.647 29.3212 105.202 30.8576C106.749 32.3949 108.657 33.1712 110.868 33.1692C113.171 33.1712 115.082 32.4063 116.532 30.8837L116.352 30.7118L116.528 30.8877C117.816 29.6001 118.456 27.8608 118.454 25.7299H118.205Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.671 19.4954H122.874V24.2277H129.003V26.0212H122.874V30.7536H129.671V32.5872H120.958V17.6618H129.671V19.4954Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.671 19.4953V19.2466H122.625V24.4764H128.755V25.7717L122.625 25.7724V31.0023H129.422V32.3384H121.206V17.9105H129.422V19.4953H129.671V19.2466V19.4953H129.92V17.6617V17.413H120.709V32.8359H129.92V30.7535V30.5048H123.123V26.27H129.252V24.2277V23.9789H123.123V19.7441H129.92V19.4953H129.671",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.758 32.5872H135.839V19.4954H131.671V17.6618H141.927V19.4954H137.758V32.5872Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.758 32.5871V32.3384H136.088V19.2466H131.919V17.9105H141.678V19.2466H137.51V32.5871H137.758V32.3384V32.5871H138.007V19.7441H142.176V17.6617V17.413H131.422V19.4953V19.7441H135.591V32.8359H137.758H138.007V32.5871H137.758",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.348 32.5872V17.6618H151.265V32.5872H149.348Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.348 32.5871H149.597V17.9105H151.016V32.3384H149.348V32.5871H149.597H149.348V32.8359H151.265H151.514V17.413H149.348H149.099V32.8359H149.348V32.5871Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.772 32.5872H157.853V19.4954H153.685V17.6618H163.941V19.4954H159.772V32.5872Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.772 32.5871V32.3384H158.102V19.2466H153.934V17.9105H163.692V19.2466H159.524V32.5871H159.772V32.3384V32.5871H160.021V19.7441H164.19V17.6617V17.413H153.436V19.4953V19.7441H157.604V32.8359H159.772H160.021V32.5871H159.772",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.829 29.4086C174.934 30.527 176.286 31.0857 177.884 31.0857C179.483 31.0857 180.835 30.527 181.938 29.4086C183.044 28.2902 183.598 26.8606 183.598 25.1242C183.598 23.3879 183.044 21.9583 181.938 20.8399C180.835 19.7215 179.483 19.1628 177.884 19.1628C176.286 19.1628 174.934 19.7215 173.829 20.8399C172.726 21.9583 172.172 23.3879 172.172 25.1242C172.172 26.8606 172.726 28.2902 173.829 29.4086ZM183.357 30.6581C181.889 32.167 180.064 32.9203 177.884 32.9203C175.702 32.9203 173.878 32.167 172.413 30.6581C170.945 29.1509 170.214 27.3058 170.214 25.1242C170.214 22.9426 170.945 21.0974 172.413 19.5904C173.878 18.0812 175.702 17.3272 177.884 17.3272C180.053 17.3272 181.873 18.0852 183.347 19.6001C184.819 21.115 185.556 22.9563 185.556 25.1242C185.556 27.3058 184.821 29.1509 183.357 30.6581Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.829 29.4088L173.652 29.5837C174.798 30.7469 176.227 31.3377 177.884 31.3347C179.54 31.3377 180.971 30.7469 182.115 29.5837C183.268 28.4195 183.848 26.9133 183.847 25.1245C183.848 23.3357 183.268 21.8294 182.115 20.6653C180.971 19.5021 179.54 18.9113 177.884 18.9143C176.227 18.9113 174.798 19.5021 173.652 20.6653C172.502 21.8294 171.921 23.3357 171.924 25.1245C171.921 26.9133 172.502 28.4195 173.652 29.5837L173.829 29.4088L174.006 29.2339C172.951 28.16 172.423 26.8093 172.421 25.1245C172.423 23.4396 172.951 22.0889 174.006 21.015C175.071 19.9414 176.343 19.4148 177.884 19.4118C179.424 19.4148 180.699 19.9414 181.761 21.015C182.818 22.0889 183.346 23.4396 183.348 25.1245C183.346 26.8093 182.818 28.16 181.761 29.2339C180.699 30.3076 179.424 30.8342 177.884 30.8372C176.343 30.8342 175.071 30.3076 174.006 29.2339L173.829 29.4088ZM183.357 30.6583L183.179 30.4854C181.753 31.9469 180.008 32.6687 177.884 32.6717C175.759 32.6687 174.015 31.9469 172.591 30.4854L172.584 30.4777L172.591 30.4854C171.168 29.019 170.465 27.2506 170.463 25.1245C170.465 22.9984 171.168 21.2299 172.591 19.7635C174.015 18.3021 175.759 17.5792 177.884 17.5762C179.995 17.5792 181.735 18.3051 183.169 19.7742C184.598 21.2474 185.304 23.013 185.307 25.1245C185.304 27.2506 184.6 29.019 183.179 30.4854L183.357 30.6583L183.536 30.8312C185.044 29.2824 185.806 27.3613 185.805 25.1245C185.806 22.9003 185.041 20.9832 183.526 19.4275C182.01 17.8658 180.111 17.076 177.884 17.0787C175.645 17.076 173.741 17.862 172.235 19.4178V19.4168C170.724 20.9665 169.964 22.8877 169.966 25.1245C169.964 27.3613 170.724 29.2824 172.235 30.8322L172.241 30.8391L172.235 30.8312C173.741 32.3869 175.645 33.1712 177.884 33.1692C180.122 33.1712 182.026 32.3869 183.536 30.8312L183.357 30.6583",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.247 32.5872V17.6618H190.581L197.835 29.2727H197.918L197.835 26.3964V17.6618H199.754V32.5872H197.752L190.163 20.4135H190.081L190.163 23.2909V32.5872H188.247Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.247 32.5871H188.496V17.9105H190.443L197.697 29.5214H197.918H198.173L198.084 26.3926V17.9105H199.505V32.3384H197.891L190.301 20.1647H190.081H189.825L189.915 23.2948V32.3384H188.247V32.5871H188.496H188.247V32.8359H190.163H190.412V23.2869L190.33 20.4068L190.081 20.4135V20.6622H190.163V20.4135L189.952 20.5458L197.614 32.8359H199.754H200.003V17.413H197.835H197.586V26.3993L197.669 29.2794L197.918 29.2727V29.0239H197.835V29.2727L198.046 29.1406L190.719 17.413H188.247H187.998V32.8359H188.247V32.5871Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.259 74.8757H270.901V43.7782H266.259V74.8757ZM308.067 54.9801L302.746 68.4625H302.587L297.065 54.9801H292.065L300.346 73.8242L295.624 84.306H300.468L313.229 54.9801H308.067ZM281.744 71.3436C280.221 71.3436 278.102 70.5836 278.102 68.7025C278.102 66.3023 280.744 65.3821 283.022 65.3821C285.065 65.3821 286.022 65.8222 287.264 66.4229C286.903 69.303 284.423 71.3436 281.744 71.3436V71.3436ZM282.304 54.2998C278.943 54.2998 275.463 55.7806 274.022 59.0612L278.142 60.7811C279.022 59.0612 280.662 58.5005 282.383 58.5005C284.784 58.5005 287.224 59.9416 287.264 62.502V62.8217C286.423 62.3416 284.624 61.6217 282.423 61.6217C277.983 61.6217 273.46 64.0615 273.46 68.6227C273.46 72.7836 277.102 75.4645 281.182 75.4645C284.304 75.4645 286.022 74.0642 287.105 72.4242H287.264V74.8242H291.744V62.9013C291.744 57.3811 287.624 54.2998 282.304 54.2998V54.2998ZM253.617 58.7657H247.015V48.1063H253.617C257.087 48.1063 259.057 50.9794 259.057 53.4359C259.057 55.8458 257.087 58.7657 253.617 58.7657ZM253.498 43.7782H242.376V74.8757H247.015V63.0938H253.498C258.642 63.0938 263.699 59.3692 263.699 53.4359C263.699 47.5028 258.642 43.7782 253.498 43.7782ZM192.848 71.3493C189.642 71.3493 186.957 68.6645 186.957 64.9769C186.957 61.2505 189.642 58.5249 192.848 58.5249C196.014 58.5249 198.499 61.2505 198.499 64.9769C198.499 68.6645 196.014 71.3493 192.848 71.3493V71.3493ZM198.178 56.7214H198.018C196.976 55.4794 194.971 54.3573 192.447 54.3573C187.157 54.3573 182.308 59.0058 182.308 64.9769C182.308 70.9083 187.157 75.517 192.447 75.517C194.971 75.517 196.976 74.3946 198.018 73.113H198.178V74.6356C198.178 78.6839 196.014 80.8478 192.528 80.8478C189.682 80.8478 187.919 78.8033 187.197 77.0804L183.15 78.7635C184.312 81.5687 187.398 85.0155 192.528 85.0155C197.978 85.0155 202.587 81.8088 202.587 73.9943V54.9986H198.178V56.7214ZM205.792 74.8757H210.441V43.7772H205.792V74.8757ZM217.294 64.6165C217.174 60.5284 220.46 58.4451 222.824 58.4451C224.669 58.4451 226.231 59.3662 226.751 60.6898L217.294 64.6165ZM231.721 61.0901C230.841 58.7249 228.154 54.3573 222.664 54.3573C217.214 54.3573 212.686 58.6453 212.686 64.9371C212.686 70.8685 217.174 75.517 223.185 75.517C228.035 75.517 230.841 72.5513 232.003 70.8284L228.396 68.4234C227.194 70.1871 225.55 71.3493 223.185 71.3493C220.821 71.3493 219.138 70.267 218.055 68.1436L232.201 62.2921L231.721 61.0901ZM119.014 57.6035V62.0918H129.754C129.434 64.6165 128.592 66.4598 127.31 67.7423C125.747 69.3058 123.302 71.0287 119.014 71.0287C112.402 71.0287 107.232 65.6988 107.232 59.0864C107.232 52.4739 112.402 47.1433 119.014 47.1433C122.581 47.1433 125.186 48.5463 127.109 50.3498L130.275 47.1841C127.591 44.6187 124.023 42.655 119.014 42.655C109.957 42.655 102.343 50.0292 102.343 59.0864C102.343 68.1436 109.957 75.517 119.014 75.517C123.904 75.517 127.591 73.9147 130.476 70.9083C133.441 67.9426 134.363 63.7749 134.363 60.409C134.363 59.3662 134.284 58.4053 134.122 57.6035H119.014ZM146.574 71.3493C143.367 71.3493 140.602 68.7043 140.602 64.9371C140.602 61.1299 143.367 58.5249 146.574 58.5249C149.779 58.5249 152.545 61.1299 152.545 64.9371C152.545 68.7043 149.779 71.3493 146.574 71.3493V71.3493ZM146.574 54.3573C140.722 54.3573 135.953 58.8055 135.953 64.9371C135.953 71.0287 140.722 75.517 146.574 75.517C152.424 75.517 157.194 71.0287 157.194 64.9371C157.194 58.8055 152.424 54.3573 146.574 54.3573ZM169.741 71.3493C166.536 71.3493 163.77 68.7043 163.77 64.9371C163.77 61.1299 166.536 58.5249 169.741 58.5249C172.947 58.5249 175.712 61.1299 175.712 64.9371C175.712 68.7043 172.947 71.3493 169.741 71.3493ZM169.741 54.3573C163.89 54.3573 159.121 58.8055 159.121 64.9371C159.121 71.0287 163.89 75.517 169.741 75.517C175.592 75.517 180.361 71.0287 180.361 64.9371C180.361 58.8055 175.592 54.3573 169.741 54.3573Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3925 80.8196L26.2077 80.6428C25.4838 79.8769 25.0565 78.6875 25.0565 77.1475V77.5099V22.495C25.0565 22.49 25.0565 22.4863 25.0565 22.4823C25.0565 22.4871 25.0565 22.491 25.0565 22.496V22.8594C25.0565 21.1918 25.5547 19.9356 26.3895 19.1823L57.2099 50.002L26.3925 80.8196ZM25.0565 22.4794C25.0565 22.3423 25.0602 22.2092 25.0672 22.0781C25.0602 22.2082 25.0565 22.3423 25.0565 22.4794ZM25.0672 22.0721C25.0672 22.0704 25.0672 22.0684 25.0679 22.0664C25.0672 22.0684 25.0672 22.0704 25.0672 22.0721ZM25.0679 22.0547C25.0679 22.0537 25.0679 22.0527 25.0679 22.0517C25.0679 22.0527 25.0679 22.0537 25.0679 22.0547Z",
    fill: "url(#paint0_linear_3_14476)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.4819 60.6429L67.7162 60.5099L79.8876 53.5942C81.048 52.9345 81.8214 52.1347 82.2072 51.2885C81.8224 52.1347 81.0488 52.9355 79.8876 53.5952L67.7162 60.5109L67.4819 60.6429V60.6429ZM67.4848 60.2785L57.21 50.0019L67.4838 39.727L79.8876 46.7738C81.4627 47.6688 82.347 48.8223 82.4948 50.0009C82.4948 50.0019 82.4948 50.0039 82.4948 50.0056C82.347 51.1815 81.4627 52.336 79.8876 53.2308L67.4848 60.2785",
    fill: "url(#paint1_linear_3_14476)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5896 81.9933C27.7286 81.9933 26.9774 81.7135 26.3915 81.1849L26.3925 81.1839C26.9784 81.7125 27.7306 81.9933 28.5915 81.9933C28.6662 81.9933 28.742 81.9914 28.8189 81.9876C28.7411 81.9914 28.6642 81.9933 28.5896 81.9933V81.9933ZM28.5906 81.6289C27.7296 81.6299 26.9784 81.3491 26.3925 80.8205V80.8197L57.21 50.002L67.4848 60.2787L31.3774 80.7943C30.3784 81.3608 29.4318 81.6289 28.5906 81.6289V81.6289ZM26.3838 81.1782C26.3294 81.1287 26.2759 81.0762 26.2234 81.0217L26.3838 81.1782Z",
    fill: "url(#paint2_linear_3_14476)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.21 50.0019L26.3896 19.1822C26.9754 18.6546 27.7257 18.3748 28.5856 18.3748C29.4291 18.3748 30.3764 18.6439 31.3774 19.2113L67.4839 39.727L57.21 50.0019V50.0019ZM67.7162 39.4949L31.3774 18.8482C30.3764 18.2805 29.4291 18.0113 28.5856 18.0113C28.5816 18.0113 28.5789 18.0113 28.5749 18.0113C28.5799 18.0113 28.5836 18.0113 28.5896 18.0113C29.4311 18.0113 30.3774 18.2795 31.3774 18.8472L67.7162 39.4949V39.4949Z",
    fill: "url(#paint3_linear_3_14476)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.819 81.9875C29.601 81.9427 30.467 81.6736 31.3774 81.1577L67.4819 60.643L31.3774 81.1577C30.4677 81.6746 29.601 81.9427 28.819 81.9875V81.9875ZM26.3916 81.1848L26.3839 81.1781C26.3866 81.1801 26.3896 81.1828 26.3916 81.1848ZM26.2234 81.0216L26.2078 81.0062V81.0052C26.2137 81.0109 26.2185 81.0166 26.2234 81.0216Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.4819 60.6429L67.7162 60.5099L67.4819 60.6429Z",
    fill: "url(#paint4_linear_3_14476)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5916 81.9933C27.7307 81.9933 26.9784 81.7125 26.3926 81.1839L26.3916 81.1849C26.3896 81.1829 26.3866 81.1802 26.3839 81.1782L26.2234 81.0217C26.2185 81.0167 26.2137 81.011 26.2078 81.0053L26.3926 80.8205C26.9784 81.3491 27.7297 81.6299 28.5906 81.6289C29.4319 81.6289 30.3784 81.3608 31.3774 80.7943L67.4849 60.2787L67.7162 60.51L67.4819 60.6431L31.3774 81.1578C30.467 81.6737 29.601 81.9428 28.819 81.9876C28.7421 81.9914 28.6662 81.9933 28.5916 81.9933",
    fill: "url(#paint5_linear_3_14476)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2077 81.0063C25.4838 80.2404 25.0565 79.0511 25.0565 77.511V77.51C25.0565 79.0511 25.4838 80.2394 26.2077 81.0053V81.0063",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2077 81.0053C25.4838 80.2394 25.0565 79.0511 25.0565 77.5101V77.1476C25.0565 78.6877 25.4838 79.877 26.2077 80.6429L26.3925 80.8198L26.2077 81.0053",
    fill: "url(#paint6_linear_3_14476)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2078 81.0053L26.3926 80.8198V80.8205L26.2078 81.0053",
    fill: "url(#paint7_linear_3_14476)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.2072 51.2885C82.3985 50.8686 82.4948 50.4373 82.4948 50.0057C82.4948 50.005 82.4948 50.004 82.4948 50.004C82.4948 50.4363 82.3985 50.8676 82.2072 51.2885Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.7161 60.5099L67.4848 60.2786L79.8875 53.2308C81.4627 52.336 82.347 51.1816 82.4948 50.0057C82.4948 50.4373 82.3985 50.8686 82.2072 51.2885C81.8214 52.1348 81.048 52.9345 79.8875 53.5942L67.7161 60.5099Z",
    fill: "url(#paint8_linear_3_14476)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.4948 50.0019V50.0009C82.4938 48.6997 81.6242 47.3987 79.8876 46.4113L67.7162 39.4957H67.7152L67.7162 39.4949L79.8876 46.4104C81.6262 47.3977 82.4968 48.7006 82.4948 50.0019Z",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.4948 50.0009C82.347 48.8223 81.4627 47.6689 79.8875 46.7738L67.4838 39.7271L67.7152 39.4957H67.7162L79.8875 46.4114C81.6241 47.3987 82.4938 48.6997 82.4948 50.0009Z",
    fill: "url(#paint9_linear_3_14476)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0565 22.4823C25.0565 22.4813 25.0565 22.4803 25.0565 22.4793C25.0565 22.4803 25.0565 22.4813 25.0565 22.4823ZM25.0672 22.0781C25.0672 22.0761 25.0672 22.0741 25.0672 22.0721C25.0672 22.0741 25.0672 22.0761 25.0672 22.0781ZM25.0679 22.0664C25.0679 22.0624 25.0679 22.0587 25.0679 22.0547C25.0679 22.0587 25.0679 22.0624 25.0679 22.0664ZM25.0679 22.0517C25.2119 19.4962 26.6015 18.0201 28.5672 18.0114C27.7149 18.0164 26.9726 18.2962 26.3915 18.8199V18.8189L26.3846 18.8258C26.3234 18.8811 26.2652 18.9395 26.2077 18.9997C25.5547 19.6905 25.1428 20.7253 25.0679 22.0517Z",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0565 22.8594V22.496C25.0565 22.491 25.0565 22.487 25.0565 22.4823C25.0565 22.4813 25.0565 22.4803 25.0565 22.4793C25.0565 22.3423 25.0602 22.2082 25.0672 22.0781C25.0672 22.0761 25.0672 22.0741 25.0672 22.0721C25.0672 22.0704 25.0672 22.0684 25.0679 22.0664C25.0679 22.0624 25.0679 22.0587 25.0679 22.0547C25.0679 22.0537 25.0679 22.0527 25.0679 22.0517C25.1428 20.7254 25.5547 19.6905 26.2077 18.9997L26.3895 19.1823C25.5547 19.9356 25.0565 21.1918 25.0565 22.8594V22.8594ZM26.3846 18.8258L26.3915 18.8189C26.3895 18.8219 26.3866 18.8239 26.3846 18.8258Z",
    fill: "url(#paint10_linear_3_14476)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.4839 39.727L31.3774 19.2113C30.3764 18.6439 29.4292 18.3748 28.5856 18.3748C27.7257 18.3748 26.9754 18.6546 26.3896 19.1822L26.2078 18.9997C26.2652 18.9395 26.3234 18.881 26.3846 18.8258C26.3866 18.8238 26.3896 18.8218 26.3916 18.8198C26.9727 18.2962 27.715 18.0163 28.5672 18.0113C28.5692 18.0113 28.5719 18.0113 28.5749 18.0113C28.5789 18.0113 28.5816 18.0113 28.5856 18.0113C29.4292 18.0113 30.3764 18.2805 31.3774 18.8482L67.7162 39.4949L67.7152 39.4957L67.4839 39.727Z",
    fill: "url(#paint11_linear_3_14476)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3_14476",
    x1: 54.4771,
    y1: 21.9147,
    x2: 12.7296,
    y2: 63.6622,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00657445,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3_14476",
    x1: 84.4139,
    y1: 50.0034,
    x2: 24.2224,
    y2: 50.0034,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3_14476",
    x1: 62.0075,
    y1: 55.7117,
    x2: 5.39477,
    y2: 112.324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3_14476",
    x1: 18.4013,
    y1: 0.68697,
    x2: 43.6811,
    y2: 25.9668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3_14476",
    x1: 84.4135,
    y1: 50.0038,
    x2: 24.2237,
    y2: 50.0038,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCB300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#CC9700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#CC8400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC7D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3_14476",
    x1: 62.0075,
    y1: 55.7117,
    x2: 5.39481,
    y2: 112.324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC2E36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C0E4E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3_14476",
    x1: 54.4772,
    y1: 21.9148,
    x2: 12.7297,
    y2: 63.6624,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008DE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00657445,
    stopColor: "#008DE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00A7E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00B8E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00C4E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C7E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3_14476",
    x1: 62.0086,
    y1: 55.7121,
    x2: 5.39667,
    y2: 112.327,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0333C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB0F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3_14476",
    x1: 84.4139,
    y1: 50.0034,
    x2: 24.2224,
    y2: 50.0034,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0C500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#E0A600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#E09100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E08900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_3_14476",
    x1: 84.4139,
    y1: 50.0034,
    x2: 24.2224,
    y2: 50.0034,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE840"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFCE40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFBC40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB540"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_3_14476",
    x1: 54.4771,
    y1: 21.9147,
    x2: 12.7296,
    y2: 63.6622,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40B8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00657445,
    stopColor: "#40B9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#40CEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#40DDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#40E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40EAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_3_14476",
    x1: 18.4013,
    y1: 0.686966,
    x2: 43.6811,
    y2: 25.9668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#65B895"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#62BD95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#50DB97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#44ED98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F498"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_14476"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 336.567,
    height: 100,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleStore);
export default __webpack_public_path__ + "static/media/googleStore.2ecb615896237379856fbe0ba7c3e712.svg";
export { ForwardRef as ReactComponent };